import React, { useEffect, useState } from 'react'
import {
  Background,
  Content,
  Title,
  Spacing,
  Breadcrumb,
  Button,
  Panel,
  Spinner,
  TextDecoration,
} from 'presentation/components'
import { Container, MessagesWrapper, Resume, ResumeRow, ResumeTitle } from './styles'
import { formatMoney } from '@/utils/functionUtils'
import Moment from 'react-moment'
import history from '@/services/history'
import { getCardsOrderSlip } from '@/services/cardsServices'
import { pushNotification } from '@/store/modules/notification/actions'
import errorHandler from '@/utils/errorHandler'
import { useDispatch } from 'react-redux'
import { useFeatures } from 'main/hooks'
import { useAtomValue } from 'jotai'
import { AccountPersistentStore } from 'main/store'

const RechargePayment = ({ ...props }) => {
  const { features } = useFeatures()
  const orderInfo = props.location?.state
  const [boletoLink, setBoletoLink] = useState(null)
  const isSlipNeeded = orderInfo.totalToPay !== 0
  const dispatch = useDispatch()
  const account = useAtomValue(AccountPersistentStore)
  useEffect(() => {
    if (!isSlipNeeded) return
    async function fetchData() {
      const { error, response } = await getCardsOrderSlip(orderInfo.id)
      if (response) setBoletoLink(response.data)
      else dispatch(pushNotification(errorHandler(error)))
    }
    fetchData()
    // eslint-disable-next-line
  }, [])

  const defineMessages = (payment) => {
    let messages = []
    if (orderInfo.totalToPay > 0)
      messages.push(
        <p key='payForTheOrder_message'>
          <TextDecoration>Parabéns!</TextDecoration> O seu pedido foi realizado com sucesso. Efetue o pagamento para que
          a recarga seja disponibilizada.
        </p>,
      )
    else if (orderInfo.totalToPay === 0)
      messages.push(
        <p key='payForTheOrder_message'>
          <TextDecoration>Parabéns!</TextDecoration> O seu pedido foi realizado com sucesso. Informações do seu pedido
          ficarão disponibilizadas no Menu “Recargas"
        </p>,
      )
    if (orderInfo.balanceUsage > 0)
      messages.push(
        <p>{`Para este pedido você utilizou R$${formatMoney(orderInfo.balanceUsage)} do seu saldo ${
          account?.resale?.digitalAccountName
        }.`}</p>,
      )
    if (orderInfo.useBalanceProjection)
      messages.push(
        <p>Você solicitou Projeção de Saldo, em até 24h você receberá um e-mail com o resultado! Fique de olho!</p>,
      )
    if (orderInfo.oldTicketingBalance > 0 && features.ticketingBalance)
      messages.push(
        <p>
          Para este pedido você utilizou R$ {formatMoney(orderInfo.oldTicketingBalance)} do seu saldo da Conta Corrente
        </p>,
      )
    return messages
  }

  return (
    <Background>
      <Content>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Title>Pagamento</Title>
        </div>
        <Spacing top='9px' bottom='9px'>
          <Breadcrumb />
        </Spacing>
        <Panel style={{ padding: '32px' }}>
          <Container>
            <Title.SubTitle>Pedido gerado!</Title.SubTitle>

            <MessagesWrapper>
              {defineMessages({ ...orderInfo.payment, useBalanceProjection: orderInfo.useBalanceProjection })}
            </MessagesWrapper>
            <Resume>
              <ResumeTitle>Pedido n° {orderInfo.code}</ResumeTitle>
              <ResumeRow>
                <p>Data da solicitação</p>
                {orderInfo.orderDate && <Moment format='DD/MM/YYYY'>{orderInfo.orderDate}</Moment>}
              </ResumeRow>
              <ResumeRow>
                <p>Total de colaboradores no pedido</p>
                <p>{orderInfo.numberOfColaborators}</p>
              </ResumeRow>

              <ResumeRow>
                <p>Total a pagar</p>
                <p>R$ {formatMoney(orderInfo.totalToPay)}</p>
              </ResumeRow>
            </Resume>
            {isSlipNeeded ? (
              <a href={boletoLink} target='_blank' rel='noreferrer noopener'>
                <Button style={{ width: '370px' }}>
                  {!boletoLink ? (
                    <>
                      <Spinner /> Gerando Boleto
                    </>
                  ) : (
                    'Baixar boleto'
                  )}
                </Button>
              </a>
            ) : (
              <Button style={{ width: '370px' }} onClick={() => history.replace('/recargas')}>
                Voltar
              </Button>
            )}
          </Container>
        </Panel>
      </Content>
    </Background>
  )
}

export default RechargePayment
